import {MinimumValue} from "../MinimumValue";
import {sprintf} from 'sprintf-js';
import {ValidatorInterface} from "../ValidatorInterface";
import {IModel} from "makerjs";
import AbstractValidatorSet from "./AbstractValidatorSet";
import Length from "../../../../../source/js/shared/models/Geometry/Length";
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";

export default class GridDrillHoleValidatorSet extends AbstractValidatorSet {
	private readonly minHoleDiameter: Length;
	private readonly state;
	private readonly drillHoles: IModel;
	private readonly parentModel: IModel;

	constructor( minHoleDiameter: Length, state, drillHoles: IModel, parentModel: IModel ) {
		super();

		this.minHoleDiameter = minHoleDiameter;
		this.state = state;
		this.drillHoles = drillHoles;
		this.parentModel = parentModel;
	}

	getValidators(): ValidatorInterface[] {
		const { drillHole } = window.measurementSelectorVariables.i18n.validators;

		return [
			new MinimumValue( {
				field: 'drillHoleDiameter',
				dimension: 'drillHoleDiameter',
				value: this.state.drillHoleDiameter,
				minimum: this.minHoleDiameter.in_mm(),
				customMessage: sprintf( drillHole.diameter.min, this.minHoleDiameter.in_cm_i18n() )
			} ),
			new MinimumValue( {
				field: 'drillHoleHorizontalAmount',
				dimension: 'drillHoleHorizontalAmount',
				value: this.state.drillHoleHorizontalAmount,
				minimum: 1,
				customMessage: sprintf( drillHole.grid.amount.horizontal, 1 )
			} ),
			new MinimumValue( {
				field: 'drillHoleVerticalAmount',
				dimension: 'drillHoleVerticalAmount',
				value: this.state.drillHoleVerticalAmount,
				minimum: 1,
				customMessage: sprintf( drillHole.grid.amount.vertical, 1 )
			} ),
			new MaximumDecimalPoints( {
				field: 'drillHoleOffset',
				dimension: 'drillHoleOffset',
				value: new Length( this.state.drillHoleOffset ).in_cm(),
				customMessage: sprintf( drillHole.offset.decimals, 1 )
			} ),
			new MaximumDecimalPoints( {
				field: 'drillHoleDiameter',
				dimension: 'drillHoleDiameter',
				value: new Length( this.state.drillHoleDiameter ).in_cm(),
				customMessage: sprintf( drillHole.diameter.decimals, 1 )
			} ),
		];
	}
}
